/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BedConflictOccupant } from './BedConflictOccupant';
import {
    BedConflictOccupantFromJSON,
    BedConflictOccupantFromJSONTyped,
    BedConflictOccupantToJSON,
} from './BedConflictOccupant';

/**
 * An outstanding bed conflict (an other-lead occupancy) that must be resolved before the Undo Move-Out can apply; null when the event was applied.
 * @export
 * @interface ResolveIntegrationEventResponseData
 */
export interface ResolveIntegrationEventResponseData {
    /**
     * The ActionConfirmation for the outstanding conflict (e.g. 'bed_conflict').
     * @type {string}
     * @memberof ResolveIntegrationEventResponseData
     */
    confirmation?: string;
    /**
     *
     * @type {BedConflictOccupant}
     * @memberof ResolveIntegrationEventResponseData
     */
    occupant?: BedConflictOccupant;
}

/**
 * Check if a given object implements the ResolveIntegrationEventResponseData interface.
 */
export function instanceOfResolveIntegrationEventResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResolveIntegrationEventResponseDataFromJSON(json: any): ResolveIntegrationEventResponseData {
    return ResolveIntegrationEventResponseDataFromJSONTyped(json, false);
}

export function ResolveIntegrationEventResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveIntegrationEventResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'confirmation': !exists(json, 'confirmation') ? undefined : json['confirmation'],
        'occupant': !exists(json, 'occupant') ? undefined : BedConflictOccupantFromJSON(json['occupant']),
    };
}

export function ResolveIntegrationEventResponseDataToJSON(value?: ResolveIntegrationEventResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'confirmation': value.confirmation,
        'occupant': BedConflictOccupantToJSON(value.occupant),
    };
}
